import { CycleType } from "../../../../constants/app-constants";
import { TableMeta } from "../../../../models/table-meta.interface";

export const CONTAINER_VIEW_PAGE_CONFIG = {
    tableMeta: {
        uniqueColumns: ["id"],
        columns: [
            {
                "fieldName": "containerNo",
                "displayName": "Container No",
                "dataType": "STRING"
            },
            {
                "fieldName": "containerSize",
                "displayName": "Size",
                "dataType": "STRING",
                "thStyleConfig": {
                    "width": "50px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "width": "40px",
                    },
                    "conditions": [
                        {
                            "expression": "eq(value, '20')",
                            "styleProperties": {
                                "border": "1px solid var(--Blue-200, #B2DDFF)",
                                "background": "var(--Blue-50, #EFF8FF)",
                                "color": "var(--Blue-700, #175CD3)"
                            }
                        },
                        {
                            "expression": "eq(value, '40')",
                            "styleProperties": {
                                "border": "1px solid var(--Purple-200, #D9D6FE)",
                                "background": "var(--Purple-50, #F4F3FF)",
                                "color": "var(--Purple-700, #5925DC)"
                            }
                        },
                        {
                            "expression": "eq(value, '45')",
                            "styleProperties": {
                                "border": "1px solid var(--Pink-200, #FCCEEE)",
                                "background": "var(--Pink-50, #FDF2FA)",
                                "color": "var(--Pink-700, #C11574)"
                            }
                        }
                    ]
                }
            },
            {
                "fieldName": "containerType",
                "displayName": "Type",
                "dataType": "STRING",
                "thStyleConfig": {
                    "width": "50px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "width": "36px",
                        "background": "var(--Gray-100, #F2F4F7)",
                        "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                    }
                }
            },
            {
                "fieldName": "shippingLine.name",
                "displayName": "Shipping Line",
                "dataType": "STRING"
            },
            {
                "fieldName": "vessel.name",
                "displayName": "Vessel",
                "dataType": "STRING"
            },
            {
                "fieldName": "vessel.viaNo",
                "displayName": "Via No",
                "dataType": "STRING"
            },
            {
                "fieldName": "vessel.igmNo",
                "displayName": "IGM No",
                "dataType": "STRING"
            },
            {
                "fieldName": "processCycle.name",
                "displayName": "Cycle",
                "dataType": "STRING"
            },
            {
                "fieldName": "gateInDate",
                "displayName": "Arrival Date",
                "dataType": "DATETIME"
            },
            {
                "fieldName": "forceGateOutDate",
                "displayName": "Force Gate Out Date",
                "dataType": "DATETIME"
            },
            {
                "fieldName": "gateOutDate",
                "displayName": "Gate Out Date",
                "dataType": "DATETIME"
            },
            {
                "fieldName": "accountHolder.name",
                "displayName": "Account Holder",
                "dataType": "STRING"
            },
            {
                "fieldName": "documentDetails",
                "displayName": "Document No",
                "dataType": "STRING",
                "styleConfig": {
                    "type": "multi-tag",
                    "multiTagConfig": {
                        "labelKey": "documentNo",
                        "maxTagCount": 1
                    }
                }

            },
            {
                "fieldName": "documentDetails",
                "displayName": "IGM Item No",
                "dataType": "STRING",
                "styleConfig": {
                    "type": "multi-tag",
                    "multiTagConfig": {
                        "labelKey": "igmItemNo",
                        "maxTagCount": 1
                    }
                }

            },
            {
                "fieldName": "blNos",
                "displayName": "BL No",
                "dataType": "STRING",
                "styleConfig": {
                    "type": "multi-tag",
                    "multiTagConfig": {
                        "maxTagCount": 1
                    }
                }

            },
            {
                "fieldName": "importType",
                "displayName": "Import Type",
                "dataType": "STRING",
                "thStyleConfig": {
                    "width": "60px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "border-radius": "6px",
                        "background": "var(--Gray-100, #F2F4F7)",
                        "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                    }
                }
            },
            {
                "fieldName": "hazardous",
                "displayName": "Hazardous",
                "dataType": "BOOLEAN",
                "thStyleConfig": {
                    "width": "80px"
                },
                "styleConfig": {
                    "type": "badge",
                    "conditions": [
                        {
                            "expression": "eq(value, 'true')",
                            "icon": "assets/icons/frame_icon.svg",
                            "iconPosition": "left",
                            "styleProperties": {
                                "border": "1px solid var(--Error-200, #FECDCA)",
                                "background": "var(--Error-50, #FEF3F2)",
                                "color": "var(--Error-700, #B42318)"
                            },
                            "iconStyleProperties": {
                                "width": "16px",
                                "height": "16px",
                                "background": "#D92D20"
                            }
                        },
                        {
                            "expression": "eq(value, 'false')",
                            "styleProperties": {
                                "border": "1px solid var(--Gray-200, #E4E7EC)",
                                "background": "var(--Gray-50, #F9FAFB)",
                                "color": "var(--Gray-700, #344054)"
                            }
                        }
                    ]
                }
            },
            {
                "fieldName": "totalPackages",
                "displayName": "NOP",
                "dataType": "STRING",
                "thStyleConfig": {
                    "width": "50px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "border-radius": "6px",
                        "font-weight": "500",
                        "line-height": "18px",
                        "background": "var(--Gray-100, #F2F4F7)",
                        "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                    }
                }
            },
            {
                "fieldName": "cargoWeight",
                "displayName": "Cargo Weight",
                "dataType": "STRING"
            },
            {
                "fieldName": "reeferPluggedIn",
                "displayName": "Reefer Plugged In",
                "dataType": "BOOLEAN",
                "thStyleConfig": {
                    "width": "80px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "width": "40px",
                    },
                    "conditions": [
                        {
                            "expression": "eq(value, 'true')",
                            "styleProperties": {
                                "border": "1px solid var(--Success-200, #ABEFC6)",
                                "background": "var(--Success-50, #ECFDF3)",
                                "color": "var(--Success-700, #067647)"
                            }
                        },
                        {
                            "expression": "eq(value, 'false')",
                            "styleProperties": {
                                "border": "1px solid var(--Gray-200, #E4E7EC)",
                                "background": "var(--Gray-50, #F9FAFB)",
                                "color": "var(--Gray-700, #344054)"
                            }
                        }
                    ]
                }
            },
            {
                "fieldName": "odc",
                "displayName": "ODC",
                "dataType": "BOOLEAN",
                "thStyleConfig": {
                    "width": "80px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "width": "40px"
                    },
                    "conditions": [
                        {
                            "expression": "eq(value, 'true')",
                            "styleProperties": {
                                "border": "1px solid var(--Success-200, #ABEFC6)",
                                "background": "var(--Success-50, #ECFDF3)",
                                "color": "var(--Success-700, #067647)"
                            }
                        },
                        {
                            "expression": "eq(value, 'false')",
                            "styleProperties": {
                                "border": "1px solid var(--Gray-200, #E4E7EC)",
                                "background": "var(--Gray-50, #F9FAFB)",
                                "color": "var(--Gray-700, #344054)"
                            }
                        }
                    ]
                }
            },
            {
                "fieldName": "dpd",
                "displayName": "DPD",
                "dataType": "BOOLEAN",
                "thStyleConfig": {
                    "width": "80px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "width": "40px",
                    },
                    "conditions": [
                        {
                            "expression": "eq(value, 'true')",
                            "styleProperties": {
                                "border": "1px solid var(--Success-200, #ABEFC6)",
                                "background": "var(--Success-50, #ECFDF3)",
                                "color": "var(--Success-700, #067647)"
                            }
                        },
                        {
                            "expression": "eq(value, 'false')",
                            "styleProperties": {
                                "border": "1px solid var(--Gray-200, #E4E7EC)",
                                "background": "var(--Gray-50, #F9FAFB)",
                                "color": "var(--Gray-700, #344054)"
                            }
                        }
                    ]
                }
            },
            {
                "fieldName": "lineSealNo",
                "displayName": "Line Seal No",
                "dataType": "STRING"
            },
            {
                "fieldName": "scanType",
                "displayName": "Scan Type",
                "dataType": "STRING"
            },
            {
                "fieldName": "scanStatus.name",
                "displayName": "Scan Status",
                "dataType": "STRING"
            },
            {
                "fieldName": "deliveryMode",
                "displayName": "Delivery Mode",
                "dataType": "STRING",
                "thStyleConfig": {
                    "width": "50px"
                },
                "styleConfig": {
                    "type": "badge",
                    "styleProperties": {
                        "border-radius": "6px",
                        "background": "var(--Gray-100, #F2F4F7)",
                        "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                    }
                }
            },
            {
                "fieldName": "fromLocation.name",
                "displayName": "From Location",
                "dataType": "STRING"
            },
            {
                "fieldName": "toLocation.name",
                "displayName": "To Location",
                "dataType": "STRING"
            },
            {
                "fieldName": "condition",
                "displayName": "Condition",
                "dataType": "STRING"
            },
            {
                "fieldName": "modifiedBy",
                "displayName": "Modified By",
                "dataType": "STRING",
                "styleConfig": {
                    "type": "user-avatar"
                }
            },
            {
                "fieldName": "modifiedDate",
                "displayName": "Modified Date",
                "dataType": "DATETIME",
                "sortable": true
            }
        ]
    } as TableMeta,

    forwardingNoteMeta: {
        uniqueColumns: ["containerId"],
        columns: [
            {
                "fieldName": "form13ReceivedDate",
                "displayName": "Form 13 Date",
                "dataType": "DATE"
            },
            {
                "fieldName": "updatedDate",
                "displayName": "Activity Date",
                "dataType": "DATE"
            },
            {
                "fieldName": "vessel.name",
                "displayName": "Vessel",
                "dataType": "STRING"
            },
            {
                "fieldName": "portOfLoading.name",
                "displayName": "POL",
                "dataType": "STRING"
            },
            {
                "fieldName": "tareWeight",
                "displayName": "Tare Wt",
                "dataType": "NUMBER"
            },
            {
                "fieldName": "cargoWeight",
                "displayName": "Cargo Wt",
                "dataType": "NUMBER"
            },
            {
                "fieldName": "lineSealNumber",
                "displayName": "Line Seal",
                "dataType": "STRING"
            },
            {
                "fieldName": "customSealNumber",
                "displayName": "Custom Seal",
                "dataType": "STRING"
            },
            {
                "fieldName": "remarks",
                "displayName": "Remarks",
                "dataType": "STRING",
            }
        ]
    } as TableMeta,

    searchBarConfig: {
        "placeHolder": "Search Container Number",
        "filters": [
            {
                "name": "CONTAINER_NO_EQUALS",
                "alias": "container_no"
            }
        ]
    },

    filterConfig: {
        "filterFields": [
            {
                "name": "CONTAINER_NO_EQUALS",
                "displayLabel": "Container No",
                "dataType": "STRING",
                "supportedOperators": [
                    "EQ"
                ],
                "operatorToFilterMap": {
                    "EQ": "CONTAINER_NO_EQUALS"
                }
            },
            {
                "name": "CARGO_SEARCH",
                "displayLabel": "Document",
                "dataType": "STRING",
                "supportedOperators": [
                    "CONTAINS"
                ],
                "operatorToFilterMap": {
                    "CONTAINS": "CARGO_SEARCH"
                }
            },
            {
                "name": "ACCOUNT_HOLDER_EQUALS",
                "displayLabel": "Account Holder",
                "dataType": "STRING",
                "supportedOperators": [
                    "EQ"
                ],
                "operatorToFilterMap": {
                    "EQ": "ACCOUNT_HOLDER_EQUALS"
                },
                "hasLookup": true,
                "searchConfig": {
                    "apiUrl": "v1/customers/list",
                    "filterByKeys": [
                        "NAME_CONTAINS"
                    ],
                    "limit": 10,
                    "orderBy": {
                        "name": "asc"
                    },
                    "bindLabel": "name",
                    "bindValue": "id",
                    "displayColumns": [
                        {
                            "key": "name",
                            "header": "Name"
                        }
                    ]
                }
            },
            {
                "name": "VESSEL_EQUALS",
                "displayLabel": "Vessel",
                "dataType": "STRING",
                "hasLookup": true,
                "supportedOperators": [
                    "EQ"
                ],
                "operatorToFilterMap": {
                    "EQ": "VESSEL_EQUALS"
                },
                "searchConfig": {
                    "apiUrl": "v1/vessel-port-train-details/list",
                    "filterByKeys": [
                        "VESSEL_NAME_CONTAINS",
                        "VIA_NO_CONTAINS"
                    ],
                    "limit": 10,
                    "orderBy": {
                        "vesselName": "asc"
                    },
                    "bindLabel": "vesselName",
                    "bindValue": "id",
                    "displayColumns": [
                        {
                            "key": "vesselName",
                            "header": "Vessel Name"
                        }
                    ],
                    "additionalFilters": {
                        "name": "IS_ACTIVE",
                        "alias": "IS_ACTIVE",
                        "operator": "EQ",
                        "value": [
                            "true"
                        ]
                    }
                }
            },
            {
                "name": "HAS_FORWARDING_NOTE",
                "displayLabel": "Has Forwarding Note",
                "dataType": "BOOLEAN",
                "supportedOperators": [
                    "EQ"
                ],
                "operatorToFilterMap": {
                    "EQ": "HAS_FORWARDING_NOTE"
                }
            },
            {
                "name": "CYCLE_EQUALS",
                "displayLabel": "Cycle",
                "dataType": "DROPDOWN",
                "supportedOperators": [
                    "EQ"
                ],
                "operatorToFilterMap": {
                    "EQ": "CYCLE_EQUALS"
                },
                options: Object.values(CycleType).map(cycle => ({
                    label: cycle.value,
                    value: cycle.key
                  }))
            },
        ],
        "useNewContract": true
    },
}
